module.exports = __webpack_public_path__ + "img/y-190.362f1b96.png";